import { SETTINGS_TYPES} from "../../../types";
import { init, success, finish, error } from "services/common";

export const todoShowZoom = (value ) =>{
    return async (dispatch) => {
      // console.log(value)
      dispatch(success(SETTINGS_TYPES.SETTINGS_EMAIL_ZOOM_SHOW , value))
    }
  }